export default __webpack_public_path__ + "static/media/marital status.9cc423e8.png";